/*
 * Author: Housefolios
 * Create Time: 2021-11-22 08:46:15
 * Modified by: TJ Felman
 * Modified time: 2025-01-27 00:00:00
 * Description: Dialog to delete a property - Refactored to use generic DeleteConfirmationDialog
 */

import React from 'react'
import { Button, ListItem } from '@mui/material'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import { useMutation } from '@apollo/client/react'
import { DELETE_PROPERTIES } from '../../Properties/mutation'
import { GET_PROPERTIES, GET_TRASH } from '../../Properties/queries'
import { GET_PORTFOLIOS } from '@/housefolios-components/Portfolio/queries'
import { GET_ME } from '@/housefolios-components/Session/queries'
import DeleteConfirmationDialog from '@/housefolios-components/Common/DeleteConfirmationDialog'
import { useDeleteConfirmation } from '@/housefolios-components/Common/DeleteConfirmationDialog/useDeleteConfirmation'

// Centralized lodash imports - much cleaner!
import { map } from '@/utils/lodash'
import { GET_PROPERTIES_QUERY_LIMIT } from '@/utils/pagination'

function DeletePropertyComponent(props) {
  const { button, rightClickMenu } = props

  const [deleteProperties] = useMutation(DELETE_PROPERTIES)

  const { open, loading, openDialog, closeDialog, handleDelete } =
    useDeleteConfirmation({
      onDelete: async () => {
        if (props.gotToPortfolio) {
          localStorage.setItem('portfolio', props.portfolioId)
        }

        await deleteProperties({
          awaitRefetchQueries: true,
          variables: { ids: props.propertyId },
          refetchQueries: [
            {
              query: GET_PROPERTIES,
              variables: {
                portfolioId: [props.portfolioId],
                limit: GET_PROPERTIES_QUERY_LIMIT,
              },
            },
            {
              query: GET_PROPERTIES,
              variables: {
                portfolioId: map(
                  props.portfolios,
                  (portfolio) => portfolio._id,
                ),
                limit: GET_PROPERTIES_QUERY_LIMIT,
              },
            },
            { query: GET_PORTFOLIOS },
            { query: GET_ME },
            { query: GET_TRASH },
          ],
        })

        if (props.setSelected) props.setSelected([])
      },
      successMessage: 'Selected Properties Deleted',
      errorMessage: 'Failed to Delete Selected Properties',
    })

  return (
    <>
      {button && (
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={openDialog}
        >
          Delete
        </Button>
      )}

      {rightClickMenu && (
        <ListItem
          onClick={openDialog}

          style={{ cursor: 'pointer' }}
          sx={{ borderRadius: '0.29rem' }}
        >
          <DeleteOutlinedIcon
            style={{ color: 'red', marginRight: '10px' }}
          />
          <span style={{ color: 'red' }}>Delete Property</span>
        </ListItem>
      )}

      <DeleteConfirmationDialog
        open={open}
        onClose={closeDialog}
        onConfirm={handleDelete}
        title="Are you sure you want to delete this?"
        confirmationText="All data will be deleted. This action cannot be undone."
        successMessage="Selected Properties Deleted"
        errorMessage="Failed to Delete Selected Properties"
        loading={loading}
        loadingMessage="Deleting Property Data"
        showSharedWarning={false}
        sharedWarningText=""
        icon="trash-can"
        iconStyle="far"
        cancelButtonText="Cancel"
        deleteButtonText="Delete"
        requireConfirmation={true}
        children={null}
      />
    </>
  )
}

export default DeletePropertyComponent
